// Customizer const
export const WINDOW_WIDTH = 'window_width';
export const SWITCH_LANGUAGE = 'switch_language';
export const OPEN_ALERTPOPUP = 'open_alertpopup';
export const OPEN_PDFPOPUP = 'open_pdfpopup';
export const OPEN_SEARCHBAR = 'open_searchBar';
export const CHANGE_PRODUCT_TAB = 'change_product_tab';
export const SET_META = 'set_meta';